/**
 * Created by jv on 24/01/2017.
 */
const utils = require("Sources/utils/utils");
const moment = require("moment");

module.exports = class Article
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.code = options.article.code;

    this.quantity = options.count;
    this.price = options.price;
    this.vat = options.vat;
    this.currency = utils.isNotNull(options.currency) ? options.currency : "EUR";

    this.type = options.article.type;
    this.title = options.article.title;
    this.author = options.article.author;
    this.description = options.article.description;
    this.publisher = options.article.publisher;
    this.image = options.article.image;
    this.download = options.article.download;

    this.purchasable = options.article.purchasable;
    this.purchaseOnce = options.article["purchase-once"];
    this.physicalDelivery = options.article["physical-delivery"];
    this.digitalDelivery = options.article["digital-delivery"];

    this.delivered = options.delivered;
  }

  get totalPriceWithCurrency()
  {
    return utils.roundNumber((this.priceWithVAT * this.quantity), 2).toFixed(2) + " " + this.currency;
  }

  get priceWithVAT()
  {
    return this.price + (this.price * this.vat);
  }

  set delivered(date)
  {
    this._delivered = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get delivered()
  {
    return utils.isMomentObject(this._delivered) ? this._delivered.format("DD-MM-YYYY") : null;
  }

  get readableDelivered()
  {
    if(this.physicalDelivery === true)
    {
      if(utils.isNotNull(this.delivered))
      {
        return this.delivered;
      }
      else
      {
        return "-";
      }
    }
    else
    {
      return "globals.not_applicable";
    }
  }
};



// WEBPACK FOOTER //
// ./app/js/models/article.js